import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentInfo } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2280. 支払情報（クレカ情報）取得
 * [GET] /workspaces/:identifier/payment_info
 */
type Props = {
  identifier: string;
};

const paymentInfo = (props: Props): Promise<PaymentInfo> => {
  return axios.get(`/api/workspaces/${props.identifier}/payment_info`, {});
};

export const usePaymentInfo = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentInfo(props),
  });
};

export const usePaymentInfoInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspace', props.identifier, 'payment_info'];
};
